import React from 'react';
import { ProductPriceCategory, ProductPriceType } from 'common/components/product-card/types';
import { hasDiscount, pricesWrapper } from './styles';
import { useProductPrice } from 'common/components/product-card/use-product-price';
import { PriceBlock } from 'fronton-react';
import { usePricePrioritization } from './use-price-prioretization';
import { cn } from 'utils/classnames';

interface SimpleProductPriceToDisplayProps {
  price: ProductPriceType;
  productPriceCategory: ProductPriceCategory;
}

export const SimpleProductPriceToDisplay: React.FC<SimpleProductPriceToDisplayProps> = ({
  price,
  productPriceCategory,
}) => {
  const { mainPrice, units } = useProductPrice({
    hasOldPrice: false,
    price,
    productPriceCategory,
  });

  const priceType = usePricePrioritization(price, productPriceCategory);

  return (
    <div className={cn(pricesWrapper, priceType === 'discount' && hasDiscount)}>
      <PriceBlock price={mainPrice} units={units} type={priceType} size="s" direction="horizontal" />
    </div>
  );
};
